<app-loader [loading]="isLoading" [fullPage]="true" [title]="'chargement'"></app-loader>
<section *ngIf="!isLoading" class="simulation grid-container grid-container--section no-gutter-mobile" data-overload-controller="AdhesionPegaseCtrl">
    <app-stepper-component [currentStepId]="'etude_dossier'"></app-stepper-component>

    <div class="simulation__group">
        <div>
            <section class="appointment-type">
                <div class="simulation__group">
                    <div class="appointment-type__header">
                        <div class="appointment-type__header-title">
                            {{ 'appointment.appointment-type.header.title' | i18n }}
                        </div>
                        <div class="appointment-type__header-icon">
                            <img alt="" data-cand-image="assets/images/logo-ARM.svg" [appAssetSrc]="'assets/images/logo-ARM.svg'" />
                        </div>
                    </div>
                    <div class="appointment-type__buttons">
                        <!-- bloc prendre rdv en ligne -->
                        <div
                            data-tag-commander=""
                            [appTagCommander]="'tagCo.appointment.appointmenttype.onlineappointment.button'"
                            class="button button--download button--noBackground appointment-type__button m-5"
                            routerLink="/souscription/appointment/appointment-planner"
                        >
                            <div class="appointment-type__button-image appointment-type__button-image--cursor"></div>
                            <div class="appointment-type__button-label">
                                <span>{{ 'appointment.appointment-type.buttons.rdv.online' | i18n }}</span>
                            </div>
                            <button type="button" class="button button--primary hide-mobile">
                                {{ 'appointment.appointment-type.buttons.rdv' | i18n }}
                            </button>
                        </div>
                        <!-- bloc etre rappele -->
                        <div data-tag-commander="" [appTagCommander]="'tagCo.appointment.appointmenttype.webcallback.button'" class="button button--download button--noBackground button--border--grey m-5 appointment-type__button" (click)="openModalVerification()">
                            <div class="appointment-type__button-image appointment-type__button-image--time"></div>
                            <div class="appointment-type__button-label" [innerHTML]="'appointment.appointment-type.buttons.rdv.time' | i18n"></div>
                            <button type="button" class="button button--rdv button--previous hide-mobile">
                                {{ 'appointment.appointment-type.buttons.rdv.call' | i18n }}
                            </button>
                        </div>
                        <!-- bloc information horaire et numero de contact -->
                        <a type="button" data-tag-commander="" [appTagCommander]="'tagCo.appointment.appointmenttype.clicktocall.button'" class="button button--download button--border--grey m-5 button--noBackground appointment-type__button">
                            <div class="appointment-type__button-image appointment-type__button-image--phone-ringing"></div>
                            <div class="appointment-type__button--phone__label-container">
                                <span class="appointment-type__button-label" [innerHTML]="'appointment.appointment-type.buttons.rdv.phone' | i18n ">
                                </span>
                                <div class="appointment-type__button-contact">
                                    <div class="appointment-type__button-contact__number">
                                        <span class="appointment-type__button-contact__number__label">
                                            {{ 'appointment.appointment-type.contact.phone' | i18n }}
                                        </span>
                                        <img class="gutter-bottom" alt="" data-cand-image="assets/images/arm-number.svg" [appAssetSrc]="'assets/images/arm-number.svg'" />
                                    </div>
                                    <div class="appointment-type__button-contact--notice">
                                        {{ 'appointment.appointment-type.contact.description' | i18n }}
                                    </div>
                                    <div class="appointment-type__button-contact--notice2">
                                        {{ 'appointment.appointment-type.contact.description2' | i18n }}
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="simulation__buttons simulation__buttons--light">
                    <div class="grid-container">
                        <div class="grid-4 grid-mobile-4">
                            <button type="button" class="button button--grey button--previous" routerLink="/souscription/document-medicale/document-list">
                                {{ 'global.button.return-to-list' | i18n }}
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</section>
<app-validation-modal-component [modalTitle]="'global.yescancel'" [content]="phoneCallBackInformation" [visibility]="showModalVerification" (leftClick)="closeModal()" (rightClick)="confirmInformation()" (crossClick)="closeModal()">
</app-validation-modal-component>
